window.resetD2C = function () {
  const blocks = document.querySelectorAll('.engraving-block');
  const modals = document.querySelectorAll('.engraving-modal');
  const carousel = document.querySelector('.product__carousel');

  blocks.forEach(block => {
    // reset inputs
    const input = block.querySelector('.engraving-input');
    if (input) input.value = '';

    // reset toggles
    block.querySelectorAll('.engraving-toggle-btn').forEach(btn => {
      btn.classList.remove('active');
    });

    block
      .querySelector('.engraving-toggle-btn[data-choice="no"]')
      ?.classList.add('active');

    // hide fields
    block.querySelector('.engraving-fields')?.classList.add('hidden');

    // reset fonts/icons
    block
      .querySelectorAll('.engraving-font, .engraving-icon')
      .forEach(b => b.classList.remove('active'));
  });

  // Clear form properties so a disabled variant can't carry engraving
  // text/font/icon into the cart from a previously selected variant.
  document
    .querySelectorAll(
      'input[name="properties[_Engraving Text]"], input[name="properties[_Engraving Font]"], input[name="properties[_Engraving Icon]"]'
    )
    .forEach(input => {
      input.value = '';
    });

  // close all modals
  modals.forEach(m => m.classList.add('hidden'));
  carousel?.classList.remove('hidden');
};

document.addEventListener('DOMContentLoaded', () => {
  // ---- Close all engraving modals except optional index ---- //
  function closeOtherModals(exceptIndex = null) {
    const allModals = document.querySelectorAll('.engraving-modal');

    allModals.forEach((modal, i) => {
      if (i !== exceptIndex) {
        modal.classList.add('hidden');
      }
    });

    // Restore carousel visibility when no modals are open
    const anyOpen = [...allModals].some(
      m => !m.classList.contains('hidden')
    );
    const carousel = document.querySelector('.product__carousel');
    if (carousel) {
      carousel.classList.toggle('hidden', anyOpen);
    }
  }

  const blocks = document.querySelectorAll('.engraving-block');
  if (!blocks.length) return;

  if (typeof liquidAjaxCart === 'undefined') {
    console.warn(
      'Liquid Ajax Cart not found — engraving hook skipped.'
    );
    return;
  }

  blocks.forEach((engravingBlock, blockIndex) => {
    /* ----------------------------------------
       GET DOM ELEMENTS INSIDE THIS BLOCK
    -----------------------------------------*/
    const modal = document.querySelectorAll('.engraving-modal')[
      blockIndex
    ];
    const carousel = document.querySelector('.product__carousel');
    const toggleBtns = engravingBlock.querySelectorAll(
      '.engraving-toggle-btn'
    );
    const fields = engravingBlock.querySelector('.engraving-fields');
    const typeBtns = engravingBlock.querySelectorAll(
      '.engraving-type-btn'
    );
    const fontBtns =
      engravingBlock.querySelectorAll('.engraving-font');
    const iconBtns =
      engravingBlock.querySelectorAll('.engraving-icon');
    const engravingInput = engravingBlock.querySelector(
      '.engraving-input'
    );

    /* ----------------------------------------
       HIDDEN PROPERTY INPUTS
       These live on the parent <form id="product-form"> — NOT inside
       .engraving-block — so we have to walk up to the form to find them.
       Caching them once keeps all the handlers below consistent.
    -----------------------------------------*/
    const productForm = engravingBlock.closest('form');
    const hiddenTextInput = productForm?.querySelector(
      'input[name="properties[_Engraving Text]"]'
    );
    const hiddenFontInput = productForm?.querySelector(
      'input[name="properties[_Engraving Font]"]'
    );
    const hiddenIconInput = productForm?.querySelector(
      'input[name="properties[_Engraving Icon]"]'
    );

    if (engravingInput) {
      engravingInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^A-Za-z0-9 ]/g, '');
        // Mirror the visible text into the form's hidden property so it
        // travels with the bottle line item to the order.
        if (hiddenTextInput) hiddenTextInput.value = this.value;
      });
    }

    const engravingText = modal?.querySelector(
      '.engraving-modal__text'
    );
    const engravingIcon = modal?.querySelector(
      '.engraving-modal__icon'
    );
    const closeBtn = modal?.querySelector('.engraving-modal__close');

    const textVariant = engravingBlock.dataset.textVariant;
    const iconVariant = engravingBlock.dataset.iconVariant;
    const engravingMode = engravingBlock.dataset.mode;

    /* ----------------------------------------
       INTERNAL STATE (per block!)
    -----------------------------------------*/
    let selectedFont = '';
    let selectedIcon = '';
    let selectedIconSrc = '';

    /* ----------------------------------------
       SET DEFAULT FONT
    -----------------------------------------*/
    if (engravingMode === 'enhanced' && fontBtns.length > 0) {
      const firstFontBtn = fontBtns[0];
      firstFontBtn.classList.add('active');
      selectedFont = firstFontBtn.dataset.font;

      if (hiddenFontInput) hiddenFontInput.value = selectedFont;

      if (engravingText)
        engravingText.style.fontFamily = selectedFont;
    }

    /* ----------------------------------------
       RESET ENGRAVING FOR THIS BLOCK
    -----------------------------------------*/
    function resetEngraving() {
      if (engravingInput) engravingInput.value = '';

      if (engravingText) {
        engravingText.textContent = 'Your text';
        engravingText.style.fontFamily = '';
      }

      if (engravingIcon) engravingIcon.innerHTML = '';

      selectedFont = '';
      selectedIcon = '';
      selectedIconSrc = '';

      fontBtns.forEach(b => b.classList.remove('active'));
      iconBtns.forEach(b => b.classList.remove('active'));

      const fontTab = engravingBlock.querySelector(
        '.engraving-type-btn[data-type="font"]'
      );
      typeBtns.forEach(b => b.classList.remove('active'));
      fontTab?.classList.add('active');

      engravingBlock
        .querySelector('.engraving-fonts')
        ?.classList.remove('hidden');
      engravingBlock
        .querySelector('.engraving-icons')
        ?.classList.add('hidden');

      if (hiddenTextInput) hiddenTextInput.value = '';
      if (hiddenFontInput) hiddenFontInput.value = '';
      if (hiddenIconInput) hiddenIconInput.value = '';
    }

    /* ----------------------------------------
       UPDATE PRICE
    -----------------------------------------*/
    function updateEngravingPrice() {
      const priceEl = engravingBlock.querySelector(
        '#engraving-price'
      );
      if (!priceEl) return;

      const standardPrice = parseInt(
        priceEl.dataset.priceStandard,
        10
      );
      const enhancedPrice = parseInt(
        priceEl.dataset.priceEnhanced,
        10
      );

      const hasText = engravingInput?.value.trim().length > 0;
      const hasIcon = !!selectedIcon;
      const offersEnhanced = priceEl.dataset.offersEnhanced === 'true';
      const amount = hasText && hasIcon ? enhancedPrice : standardPrice;

      priceEl.textContent = offersEnhanced
        ? `from ${formatMoney(amount)}`
        : formatMoney(amount);
    }

    /* ----------------------------------------
       UPDATE PREVIEW
    -----------------------------------------*/
    function updatePreview() {
      const text = engravingInput?.value.trim() || '';

      if (engravingText) {
        engravingText.textContent = text || 'Your text';
        if (selectedFont)
          engravingText.style.fontFamily = selectedFont;
      }

      if (engravingIcon) {
        engravingIcon.innerHTML = '';
        if (selectedIconSrc) {
          const img = document.createElement('img');
          img.src = selectedIconSrc;
          engravingIcon.appendChild(img);
        }
      }
    }

    function updateIconPosition(icon, variantId) {
      const dataEl = document.getElementById(
        'variantData-' + variantId
      );
      if (!dataEl) {
        return;
      }

      const variantData = JSON.parse(dataEl.textContent || '{}');
      const position = variantData[variantId]?.engraving_position;
      if (position) {
        if (icon == 'shark') {
          engravingIcon.style.top = 'unset';
          engravingIcon.style.bottom = position[0] + '%';
          engravingText.style.top = '53%';
          engravingText.style.bottom = 'unset';
          engravingIcon.classList.add('icon-shark');
        } else {
          engravingText.style.top = 'unset';
          engravingText.style.bottom = position[0] + '%';
          engravingIcon.style.top = '50%';
          engravingIcon.style.bottom = 'unset';
          engravingIcon.classList.remove('icon-shark');
        }
      }
    }

    document.addEventListener('engraving:resize', event => {
      const variantId =
        event?.detail?.variantId ||
        document.getElementById('product-select')?.value ||
        '';
      if (!variantId) return;

      const activeIconBtn = engravingBlock.querySelector(
        '.engraving-icon.active'
      );
      const iconKey = activeIconBtn?.dataset.icon || selectedIcon;
      if (!iconKey) return;

      updateIconPosition(iconKey, variantId);
    });

    engravingInput?.addEventListener('input', () => {
      updatePreview();
      updateEngravingPrice();
    });

    /* ----------------------------------------
       FONT / ICON SWITCHING
    -----------------------------------------*/
    typeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        typeBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const type = btn.dataset.type;
        engravingBlock
          .querySelector('.engraving-fonts')
          ?.classList.toggle('hidden', type !== 'font');
        engravingBlock
          .querySelector('.engraving-icons')
          ?.classList.toggle('hidden', type !== 'icon');
      });
    });

    /* ----------------------------------------
       FONT SELECT
    -----------------------------------------*/
    fontBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        fontBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        selectedFont = btn.dataset.font;
        if (hiddenFontInput) hiddenFontInput.value = selectedFont;

        updatePreview();
      });
    });

    /* ----------------------------------------
       ICON SELECT (toggleable)
    -----------------------------------------*/
    iconBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const alreadyActive = btn.classList.contains('active');

        iconBtns.forEach(b => b.classList.remove('active'));

        if (alreadyActive) {
          selectedIcon = '';
          selectedIconSrc = '';
        } else {
          btn.classList.add('active');
          selectedIcon = btn.dataset.icon;
          selectedIconSrc = btn.dataset.iconSrc;
        }

        if (hiddenIconInput) hiddenIconInput.value = selectedIcon;

        const variantId =
          document.getElementById('product-select').value;

        updatePreview();
        updateEngravingPrice();
        updateIconPosition(selectedIcon, variantId);
      });
    });

    /* ----------------------------------------
       OPEN / CLOSE MODAL
    -----------------------------------------*/
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        toggleBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const choice = btn.dataset.choice;

        if (choice === 'yes') {
          closeOtherModals(blockIndex);
          fields.classList.remove('hidden');
          modal?.classList.remove('hidden');
          carousel?.classList.add('hidden');
        } else {
          resetEngraving();
          fields.classList.add('hidden');
          modal?.classList.add('hidden');
          carousel?.classList.remove('hidden');
        }

        updateEngravingPrice();
      });
    });

    closeBtn?.addEventListener('click', () => {
      modal.classList.add('hidden');
      carousel?.classList.remove('hidden');
    });

    /* ----------------------------------------
       ADD TO CART LOGIC (MULTIPLE BLOCKS)
    -----------------------------------------*/
    liquidAjaxCart.subscribeToCartAjaxRequests(
      (state, subscribeToResult) => {
        if (state.requestType !== 'add') return;

        const form = state.info.initiator;
        if (!form) return;

        const yesSelected = engravingBlock
          .querySelector('.engraving-toggle-btn[data-choice="yes"]')
          ?.classList.contains('active');

        if (!yesSelected) return;

        // Variant metafield engraving.disabled — do not add engraving
        if (
          engravingBlock.classList.contains(
            'engraving-variant-disabled'
          )
        ) {
          return;
        }

        let mainVariant =
          form.querySelector('input[name="properties[_Line UID]"]')
            ?.value || form.querySelector('[name=id]')?.value;

        if (!mainVariant) return;

        const engravingValue =
          engravingInput?.value.trim() ||
          engravingText?.textContent ||
          'Custom engraving';

        let engravingVariant = textVariant;
        if (engravingInput?.value.trim() && selectedIcon) {
          engravingVariant = iconVariant;
        }

        const productTitle = window.productJSON.title;
        // 1 — Try normal product selectors first
        let selectedColor =
          document.querySelector(
            '.product__variant-pills[data-option-name*="olour"] .active'
          )?.dataset.value || '';

        let selectedSize =
          document.querySelector(
            '.product__variant-pills[data-option-name*="ize"] .active'
          )?.dataset.value || '';

        // 2 — If nothing found, it's a bundle → use engraving block’s local selectors
        if (!selectedColor && !selectedSize) {
          const optionGroup = engravingBlock
            .closest('.product__variant')
            ?.querySelector('.product__variant-pills');

          selectedColor =
            optionGroup?.querySelector(
              '.variant-pill.active[data-option-name*="olour"]'
            )?.dataset.value || '';

          selectedSize =
            optionGroup?.querySelector(
              '.variant-pill.active[data-option-name*="ize"]'
            )?.dataset.value || '';
        }

        subscribeToResult(async result => {
          if (!result.responseData.ok) return;

          try {
            await new Promise(r => setTimeout(r, 150));

            const productSummary = [
              productTitle,
              selectedColor,
              selectedSize
            ]
              .filter(Boolean)
              .join(' · ');

            // Build the properties object for the engraving line item.
            // _Engraving ID links this line back to its bottle via the
            // bottle's _Line UID so cart removal can pair them up.
            const properties = {
              '_Engraving For': mainVariant,
              '_Engraving ID':
                form.querySelector(
                  'input[name="properties[_Line UID]"]'
                )?.value || '',
              '_Component Index': blockIndex + 1,
              'Engraving Bottle': productSummary
            };

            if (engravingInput?.value.trim()) {
              properties['Engraving Text'] = [
                engravingValue,
                selectedFont
              ]
                .filter(Boolean)
                .join(' · ');
            }

            if (selectedIcon) {
              properties['Engraving Icon'] = selectedIcon;
            }

            await liquidAjaxCart.cartRequestAdd({
              id: parseInt(engravingVariant, 10),
              quantity: 1,
              properties
            });
          } catch (err) {
            console.error(
              `Engraving add failed for block ${blockIndex + 1}:`,
              err
            );
          }
        });
      }
    );
  });

  let bundleToRemove = null;

  document.addEventListener('mousedown', e => {
    const btn = e.target.closest('.cart-modal__item-lower--remove');
    if (!btn) return;

    const itemEl = btn.closest('.cart-modal__item');
    if (!itemEl) return;

    const propsEl = itemEl.querySelector(
      '[data-line-item-properties-json]'
    );
    if (!propsEl) return;

    let props;

    try {
      props = JSON.parse(propsEl.textContent); // ← array of arrays
    } catch (err) {
      return;
    }

    // Convert array entries → object
    const obj = Object.fromEntries(props);

    bundleToRemove = obj['_Line UID'] || obj['_Engraving ID'] || null;
  });

  liquidAjaxCart.subscribeToCartAjaxRequests(
    (state, afterRequest) => {
      if (state.requestType !== 'change') return; // Only on remove/change
      if (!bundleToRemove) return;

      afterRequest(async () => {
        try {
          // Fetch REAL Shopify cart (bypasses Liquid Ajax Cart Lite limitations)
          const res = await fetch('/cart.js');
          const cart = await res.json();

          for (let i = cart.items.length - 1; i >= 0; i--) {
            let props = cart.items[i].properties || {};

            if (
              String(props['_Line UID']) === String(bundleToRemove) ||
              String(props['_Engraving ID']) ===
                String(bundleToRemove)
            ) {
              await liquidAjaxCart.cartRequestChange({
                line: i + 1,
                quantity: 0
              });
            }
          }

          bundleToRemove = null;
        } catch (err) {
          console.error('Engraving cleanup failed:', err);
        }
      });
    }
  );
});
